export default {
  data () {
    return {
    }
  },
  methods: {
    saveDefTemplate(ID) {
      return this.$http({method: 'POST', url: api+'api/v2/feedstation/template/default?template='+ID, body: JSON.stringify({template: ID})})
    },
    getDefaultTemplate(Name) {
      return this.$http({method: 'GET', url: api+'api/v2/feedstation/template/default', body: JSON.stringify({name: Name})})
    },
    createTemplate(Name) {
      return this.$http({method: 'POST', url: api+'api/v2/feedstation/templates/create', body: JSON.stringify({name: Name})})
    },
    resetTemplate(Template) {
      return this.$http({method: 'POST', url: api+'api/v2/feedstation/templates/reset?template='+Template, body: null})
    },
    saveTemplate(Template, b, sport, name) {
      return this.$http({method: 'POST', url: api+'api/v2/feedstation/templates/save?name='+name+'&sport='+sport+'&template='+Template, body: JSON.stringify(b)})
    },
    fetchTemplates() {
      return this.$http.get(api+'api/v2/feedstation/templates?locale='+window.locale)
    },
    getMarketList(SportId, TemplateId) {
      return this.$http.get(api+'api/v2/feedstation/templates/market?template='+TemplateId+'&sport='+SportId+'&locale='+window.locale)
    },
    fetchSport() {
      return this.$http.get(api+'api/v2/feedstation/templates/sport?locale='+window.locale)
    },
    saveSport(b) {
      return this.$http({method: 'POST', url: api+'api/v2/feedstation/templates/sport', body: JSON.stringify(b)})
    },
    fetchAllClass() {
      return this.$http.get(api+'api/v1/odd-feed/class?all=1')
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/feed.js